<template>
	<article class="content list-page">
		<header class="rigid">
			<h1>My Account</h1>
			<p class="gray-6">Manage your account settings to get the most out of Initial State.</p>
		</header>
		<!-- turn these into components -->
		<section class="rigid">
			<h3>Quick Actions</h3>
			<div class="row cards cards-actions separated separated-extra">
				<router-link class="gap card card-secondary" to="/subscriptions/iot">
					<div class="row">
						<i class="fas fa-sync-alt jumbo flexible"></i>
						<span v-if="iotSub" class="rigid gray-5">
							{{iotSub.plan.name}} plan
						</span>

						<span class="rigid gray-6"></span>
					</div>
					<h4 v-if="iotSub">Change Subscription</h4>
					<h4 v-else>Start Subscription</h4>
				</router-link>
				<router-link class="gap card card-secondary" to="/payments/method?returnPath=%2F">
					<div class="row">
						<i class="fas fa-credit-card flexible jumbo"></i>
						<span v-if="account && account.paymentMethod" class="rigid gray-5">
							<i class="cc fab" :class="'fa-cc-' + account.paymentMethod.brand.toLowerCase()"></i>  {{account.paymentMethod.last4}}
						</span>
					</div>
					<h4 v-if="account && account.paymentMethod">Change Payment Method</h4>
					<h4 v-else>Add Payment Method</h4>
				</router-link>
				<router-link class="gap card card-secondary" to="/payments">
					<div class="row">
						<i class="fas fa-file-invoice-dollar flexible jumbo"></i>
						<!-- maybe show upcoming payment info? -->
					</div>
					<h4 >View Payments</h4>
				</router-link>
			</div>
		</section>

		<section>
			<h3>Security</h3>
			<security-partial></security-partial>
		</section>

		<section>
			<h3>Preferences</h3>
			<span class="list-group">
				<setting-toggle
					class="ignore-active"
					can-edit="!userStatus.loading"
					v-on:change="toggleDataCollection"
					:model="user.allowDataCollection"
					:label="'Allow app usage data collection'">
					<!-- field assist slot -->
					<div slot="field-assist" class="field-assist">
						All Personal Information collected or used will be subject to the <a href="https://www.tek.com/en/privacy-statement">Tektronix Privacy Policy</a>.
						<div class="is-support">
							For additional information, read the <a href="https://www.initialstate.com/terms" rel="license">website terms</a> or contact <a href="mail:support@initialstate.com">support@initialstate.com</a>.
						</div>
					</div>
				</setting-toggle>
			</span>
		</section>
	</article>
</template>

<script>
// import SettingToggle from '../components/SettingToggle';
import SettingToggle from '../components/SettingToggle';
import Spinner from '../components/Spinner';
import Security from '../views/Security';
import SecurityPartial from '../views/Security.partial';
import Personal from '../views/Personal';
import consentService from '@/modules/consent-service';
import { mapGetters, mapState, mapActions } from 'vuex';

export default {
	name: 'ISHome',
	computed: {
		...mapGetters([
			'user',
			'userStatus',
			'account'
		]),
		...mapGetters('consent', [
			'showConsentNotice',
			'marketingEnabled'
		]),
		...mapGetters('subscription', {
			iotSub: 'iotSubscription'
		}),
		...mapState('consent', [
			'marketingEnabledAnswer'
		]),
		showPersonalSection() {
			return this.$root.isTek && this.user.address;
		}
	},
	data() {
		return {
			password: '',
			loadingMarketingFlag: false
		};
	},
	components: {
		SettingToggle,
		SecurityPartial,
		Personal,
		Spinner
	},
	methods: {
		...mapActions('consent',{
			setMarketingFlag: 'SET_MARKETING_ANSWER'
		}),
		toggleDataCollection(enabled) {
			this.$store.dispatch('RESET_USER_STATUS');
			this.updateDataCollection(enabled);
		},
		toggleMarketingOptIn(enabled) {
			this.$store.dispatch('RESET_USER_STATUS');
			const answer = enabled ? 'yes' : 'no';
			consentService.setMarketingFlag(answer)
				.then(() => {
					this.setMarketingFlag(answer);
				});
		},
		updateDataCollection(enabled) {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('UPDATE_USER_REQUEST', {
					trackingEnabled: enabled
				})
					.then(response => {
						resolve(response);
					})
					.catch(reason => {
						reject(reason);
					});
			});
		},
		// resetState() {
		// 	this.$store.dispatch('RESET_USER_STATUS');
		// }
	},
	created(){
		let vm = this;
		if (!this.marketingEnabledAnswer && this.$root.isTek) {
			consentService.getMarketingFlag()
				.then((answer) => {
					vm.setMarketingFlag(answer);
				});
		}
		this.$store.dispatch('subscription/GET_SUBSCRIPTIONS_REQUEST');

	},
	mounted(){
		document.documentElement.classList.remove('navigating', 'initializing');
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// ./src/views/ISHome.vue